import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import { PhClockCounterClockwise } from 'ember-phosphor-icons';
import pageTitle from 'ember-page-title/helpers/page-title';
import PartnerReportsPage from 'tio-reporting/components/partner-reports-page';
import { Section, VStack } from 'tio-ui/components/layout';
import { SCHEDULED_EXPORTS_FEATURE_FLAG } from 'tio-employee/types/scheduled-exports';
import type FeaturesService from 'tio-common/services/features';
import type SessionContextService from 'tio-employee/services/session-context';
import { reportingCompanyId } from 'tio-employee/utils/reporting-company';

interface S {
  Args: {
    model: {
      id: string;
    };
  };
}

class ReportingIndexRoute extends Component<S> {
  @service declare sessionContext: SessionContextService;
  @service declare features: FeaturesService;

  get companyId() {
    const { rolesForCurrentCompany, currentCompany } = this.sessionContext;
    return reportingCompanyId(rolesForCurrentCompany, currentCompany?.id ?? undefined);
  }

  get showScheduledExports() {
    return this.features.isEnabled(SCHEDULED_EXPORTS_FEATURE_FLAG);
  }

  <template>
    {{pageTitle (t "reporting.reports")}}
    <VStack>
      {{#if this.companyId}}
        <Section>
          <:header>{{t "reporting.reports"}}</:header>
          <:body>
            {{#if this.showScheduledExports}}
              <LinkTo
                @route="authenticated.admin.reporting.exports"
                class="tio-inline-row-extra-tight w-fit tio-text-sm-medium tio-fg-info-h hover:tio-fg-info"
                data-test-scheduled-exports-link
              >
                <PhClockCounterClockwise class="h-4 w-4" />
                {{t "reporting.scheduled_exports"}}
              </LinkTo>
            {{/if}}
            {{! Partner launch scope: TAS reports only for now — other product
                types (syf, pslf, slr, dashboards) stay admin-side even when
                published, until each product is cleared for partner rollout. }}
            <PartnerReportsPage
              @companyId={{this.companyId}}
              @viewerRoute="authenticated.admin.reporting.report-viewer"
              @reportTypes={{array "tas"}}
            />
          </:body>
        </Section>
      {{/if}}
    </VStack>
  </template>
}

export default ReportingIndexRoute;
